module.exports = __webpack_public_path__ + "static/media/logo.a22eb533.png";